import { BaseEditModel } from "model/BaseEditModel";
import Produto from "./Produto";
import Estagio from "model/producao/Estagio";
import EstagioRoteiro from "model/producao/EstagioRoteiro";

export default class ComponenteProduto implements BaseEditModel {
    id: number;
    key: string = "";
    codigo: string = "";
	produto: Produto|null;
	estagioRoteiro: EstagioRoteiro;
	sequencial: number;
	componente: Produto;
	quantidade: number;
    observacao: string;

    constructor(
        id = 0,
        produto = null,
        estagioRoteiro = new EstagioRoteiro(),
        sequencial = 0,
        componente = new Produto(),
        quantidade = 0,
        observacao = ""
    ) {
        this.id = id;
        this.produto = produto;
        this.estagioRoteiro = estagioRoteiro;
        this.sequencial = sequencial;
        this.componente = componente;
        this.quantidade = quantidade;
        this.observacao = observacao;
    }
}